import { h } from 'preact'
import images from '../images'
import infoLinkView from './info-link'

export default function infoButtonView ({ tutorial }) {
  return infoLinkView({ tutorial, cssClass: 'info-button' },
    h('img', { src: images['info-button.svg'] }))
}
